import { confidenceBand } from '@/hooks/useOcr';

const COLORS = {
  green: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  red:   'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  gray:  'bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300',
} as const;

export function ConfidencePill({
  confidence,
  compact = false,
}: {
  confidence: string | number | null | undefined;
  compact?: boolean;
}) {
  const { label, color } = confidenceBand(confidence);
  const cls = COLORS[color];
  const sizing = compact ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';
  return (
    <span className={`inline-flex items-center rounded font-medium ${cls} ${sizing}`}>
      {label}
    </span>
  );
}
